import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { CaDesignModule } from '../../../../../ca-design/ca-design.module';

@Component({
  selector: 'ca-media-upload-error-overlay',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, TranslateModule, CaDesignModule],
  templateUrl: './media-upload-error-overlay.component.html',
  styleUrls: ['./media-upload-error-overlay.component.scss'],
})
export class MediaUploadErrorOverlayComponent {
  @Input() errorMessage: string = '';
  @Output() retry = new EventEmitter<void>();
  @Output() remove = new EventEmitter<void>();
}
